export const zipCodes: readonly number[] = [
  30002, 30004, 30005, 30008, 30009, 30011, 30012, 30013, 30014, 30016, 30017,
  30018, 30019, 30021, 30022, 30024, 30025, 30028, 30030, 30032, 30033, 30034,
  30035, 30038, 30039, 30040, 30041, 30043, 30044, 30045, 30046, 30047, 30052,
  30054, 30055, 30056, 30058, 30060, 30062, 30064, 30066, 30067, 30068, 30070,
  30071, 30072, 30075, 30076, 30078, 30079, 30080, 30082, 30083, 30084, 30087,
  30088, 30090, 30092, 30093, 30094, 30096, 30097, 30101, 30102, 30104, 30106,
  30107, 30110, 30111, 30113, 30114, 30115, 30116, 30117, 30118, 30120, 30121,
  30122, 30126, 30127, 30132, 30134, 30135, 30137, 30139, 30141, 30143, 30144,
  30145, 30148, 30152, 30153, 30157, 30168, 30171, 30177, 30178, 30179, 30180,
  30182, 30183, 30184, 30185, 30187, 30188, 30189, 30205, 30206, 30213, 30214,
  30215, 30216, 30218, 30220, 30223, 30224, 30228, 30229, 30233, 30234, 30236,
  30238, 30248, 30250, 30251, 30252, 30253, 30257, 30259, 30260, 30263, 30265,
  30268, 30269, 30272, 30273, 30274, 30275, 30276, 30277, 30281, 30284, 30288,
  30289, 30290, 30291, 30292, 30294, 30295, 30296, 30297, 30301, 30302, 30303,
  30304, 30305, 30306, 30307, 30308, 30309, 30310, 30311, 30312, 30313, 30314,
  30315, 30316, 30317, 30318, 30319, 30320, 30321, 30322, 30324, 30325, 30326,
  30327, 30328, 30329, 30331, 30332, 30333, 30334, 30336, 30337, 30338, 30339,
  30340, 30341, 30342, 30343, 30344, 30345, 30346, 30349, 30350, 30354, 30355,
  30356, 30357, 30358, 30359, 30360, 30361, 30362, 30363, 30364, 30366, 30368,
  30369, 30377, 30378, 30380, 30385, 30388, 30396, 30398, 30504, 30506, 30507,
  30517, 30518, 30519, 30534, 30542, 30548, 30566, 30575, 30620, 30623, 30641,
  30655, 30656, 30663, 30666, 30680, 31085, 31106, 31107, 31119, 31126, 31131,
  31136, 31139, 31141, 31145, 31146, 31150, 31156, 39901, 44001, 44010, 44011,
  44012, 44017, 44021, 44022, 44023, 44024, 44026, 44028, 44035, 44039, 44040,
  44041, 44044, 44045, 44046, 44049, 44050, 44052, 44053, 44054, 44055, 44056,
  44057, 44060, 44062, 44064, 44065, 44067, 44070, 44072, 44074, 44076, 44077,
  44080, 44081, 44084, 44085, 44086, 44087, 44089, 44090, 44092, 44094, 44095,
  44099, 44101, 44102, 44103, 44104, 44105, 44106, 44107, 44108, 44109, 44110,
  44111, 44112, 44113, 44114, 44115, 44116, 44117, 44118, 44119, 44120, 44121,
  44122, 44123, 44124, 44125, 44126, 44127, 44128, 44129, 44130, 44131, 44132,
  44133, 44134, 44135, 44136, 44137, 44138, 44139, 44140, 44141, 44142, 44143,
  44144, 44145, 44146, 44147, 44149, 44181, 44195, 44199, 44201, 44202, 44203,
  44212, 44214, 44215, 44216, 44217, 44221, 44223, 44224, 44230, 44231, 44232,
  44233, 44234, 44235, 44236, 44240, 44241, 44243, 44250, 44251, 44253, 44254,
  44255, 44256, 44260, 44262, 44264, 44266, 44270, 44272, 44273, 44274, 44275,
  44276, 44278, 44280, 44281, 44285, 44286, 44287, 44288, 44301, 44302, 44303,
  44304, 44305, 44306, 44307, 44308, 44310, 44311, 44312, 44313, 44314, 44319,
  44320, 44321, 44325, 44333, 44401, 44402, 44411, 44412, 44429, 44430, 44439,
  44444, 44449, 44450, 44470, 44481, 44483, 44485, 44491, 44601, 44614, 44618,
  44630, 44632, 44640, 44641, 44645, 44646, 44647, 44652, 44666, 44667, 44677,
  44685, 44691, 44702, 44703, 44705, 44708, 44709, 44710, 44714, 44718, 44720,
  44721, 44814, 44826, 44839, 44846, 44851, 44859, 44866, 44880, 44889, 46301,
  46302, 46303, 46304, 46307, 46311, 46312, 46319, 46320, 46321, 46322, 46323,
  46324, 46327, 46341, 46342, 46356, 46360, 46368, 46373, 46375, 46376, 46383,
  46385, 46391, 46393, 46394, 46402, 46403, 46404, 46405, 46406, 46407, 46408,
  46409, 46410, 49117, 49129, 53142, 53143, 53158, 60002, 60004, 60005, 60007,
  60008, 60010, 60012, 60013, 60014, 60015, 60016, 60018, 60020, 60021, 60022,
  60025, 60026, 60029, 60030, 60031, 60035, 60040, 60041, 60042, 60043, 60044,
  60045, 60046, 60047, 60048, 60050, 60051, 60053, 60056, 60060, 60061, 60062,
  60064, 60067, 60068, 60069, 60070, 60072, 60073, 60074, 60075, 60076, 60077,
  60081, 60083, 60084, 60085, 60087, 60088, 60089, 60090, 60091, 60093, 60096,
  60099, 60101, 60102, 60103, 60104, 60106, 60107, 60108, 60109, 60110, 60118,
  60119, 60120, 60123, 60124, 60126, 60130, 60131, 60133, 60134, 60136, 60137,
  60139, 60140, 60141, 60142, 60143, 60144, 60148, 60151, 60153, 60154, 60155,
  60156, 60157, 60160, 60162, 60163, 60164, 60165, 60169, 60171, 60172, 60173,
  60174, 60175, 60176, 60177, 60181, 60183, 60184, 60185, 60187, 60188, 60189,
  60190, 60191, 60192, 60193, 60194, 60195, 60201, 60202, 60203, 60208, 60301,
  60302, 60304, 60305, 60401, 60402, 60403, 60404, 60406, 60409, 60410, 60411,
  60415, 60417, 60418, 60419, 60421, 60422, 60423, 60425, 60426, 60428, 60429,
  60430, 60431, 60432, 60433, 60435, 60436, 60438, 60439, 60440, 60441, 60442,
  60443, 60445, 60446, 60447, 60448, 60449, 60451, 60452, 60453, 60455, 60456,
  60457, 60458, 60459, 60461, 60462, 60463, 60464, 60465, 60466, 60467, 60468,
  60469, 60471, 60472, 60473, 60475, 60476, 60477, 60478, 60480, 60481, 60482,
  60484, 60487, 60490, 60491, 60501, 60502, 60503, 60504, 60505, 60506, 60510,
  60511, 60512, 60513, 60514, 60515, 60516, 60517, 60519, 60521, 60523, 60525,
  60526, 60527, 60532, 60534, 60538, 60539, 60540, 60542, 60543, 60544, 60545,
  60546, 60554, 60555, 60558, 60559, 60560, 60561, 60563, 60564, 60565, 60585,
  60586, 60601, 60602, 60603, 60604, 60605, 60606, 60607, 60608, 60609, 60610,
  60611, 60612, 60613, 60614, 60615, 60616, 60617, 60618, 60619, 60620, 60621,
  60622, 60623, 60624, 60625, 60626, 60628, 60629, 60630, 60631, 60632, 60633,
  60634, 60636, 60637, 60638, 60639, 60640, 60641, 60642, 60643, 60644, 60645,
  60646, 60647, 60649, 60651, 60652, 60653, 60654, 60655, 60656, 60657, 60659,
  60660, 60661, 60666, 60668, 60669, 60670, 60673, 60674, 60675, 60677, 60678,
  60682, 60684, 60685, 60686, 60687, 60688, 60689, 60690, 60693, 60694, 60695,
  60697, 60699, 60701, 60706, 60707, 60712, 60714, 60803, 60804, 60805, 60827,
  60914, 60940, 60950, 85131, 85132, 85141, 85145, 85601, 85602, 85611, 85614,
  85618, 85619, 85622, 85623, 85627, 85629, 85631, 85637, 85640, 85641, 85645,
  85646, 85653, 85654, 85658, 85701, 85702, 85703, 85704, 85705, 85706, 85707,
  85708, 85709, 85710, 85711, 85712, 85713, 85714, 85715, 85716, 85717, 85718,
  85719, 85721, 85723, 85724, 85725, 85726, 85728, 85730, 85731, 85732, 85733,
  85734, 85735, 85736, 85737, 85739, 85740, 85741, 85742, 85743, 85744, 85745,
  85746, 85747, 85748, 85749, 85750, 85751, 85752, 85754, 85755, 85756, 85757,
  86409, 86411, 86413, 86426, 86429, 86431, 86433, 86440, 86441, 86442, 86443,
  86445, 89002, 89004, 89005, 89011, 89012, 89014, 89015, 89018, 89019, 89021,
  89025, 89026, 89029, 89030, 89031, 89032, 89039, 89040, 89044, 89046, 89048,
  89052, 89054, 89061, 89070, 89074, 89081, 89084, 89085, 89086, 89101, 89102,
  89103, 89104, 89105, 89106, 89107, 89108, 89109, 89110, 89111, 89112, 89113,
  89114, 89115, 89116, 89117, 89118, 89119, 89120, 89121, 89122, 89123, 89124,
  89125, 89126, 89127, 89128, 89129, 89130, 89131, 89132, 89133, 89134, 89135,
  89136, 89137, 89138, 89139, 89140, 89141, 89142, 89143, 89144, 89145, 89146,
  89147, 89148, 89149, 89150, 89151, 89152, 89153, 89154, 89155, 89156, 89157,
  89158, 89160, 89161, 89162, 89165, 89166, 89169, 89170, 89173, 89178, 89179,
  89180, 89183, 89191, 89193, 89195, 89199, 89402, 89411, 89413, 89423, 89448,
  89449, 89450, 89451, 89460, 89703, 89705, 94002, 94005, 94010, 94014, 94015,
  94018, 94019, 94020, 94021, 94022, 94024, 94025, 94027, 94028, 94030, 94037,
  94038, 94040, 94041, 94043, 94044, 94060, 94061, 94062, 94063, 94065, 94066,
  94070, 94074, 94080, 94085, 94086, 94087, 94089, 94102, 94103, 94104, 94105,
  94107, 94108, 94109, 94110, 94111, 94112, 94114, 94115, 94116, 94117, 94118,
  94119, 94121, 94122, 94123, 94124, 94125, 94126, 94127, 94128, 94129, 94130,
  94131, 94132, 94133, 94134, 94140, 94141, 94143, 94146, 94147, 94158, 94159,
  94164, 94188, 94301, 94303, 94304, 94305, 94306, 94401, 94402, 94403, 94404,
  94501, 94502, 94503, 94505, 94506, 94507, 94509, 94510, 94511, 94512, 94513,
  94514, 94516, 94517, 94518, 94519, 94520, 94521, 94523, 94525, 94526, 94528,
  94530, 94531, 94533, 94534, 94535, 94536, 94538, 94539, 94541, 94542, 94544,
  94545, 94546, 94547, 94548, 94549, 94550, 94551, 94552, 94553, 94555, 94556,
  94558, 94559, 94560, 94561, 94562, 94563, 94564, 94565, 94566, 94568, 94569,
  94571, 94572, 94573, 94575, 94577, 94578, 94579, 94580, 94582, 94583, 94585,
  94586, 94587, 94588, 94589, 94590, 94591, 94592, 94595, 94596, 94597, 94598,
  94599, 94601, 94602, 94603, 94604, 94605, 94606, 94607, 94608, 94609, 94610,
  94611, 94612, 94613, 94614, 94615, 94618, 94619, 94621, 94623, 94624, 94661,
  94666, 94702, 94703, 94704, 94705, 94706, 94707, 94708, 94709, 94710, 94720,
  94801, 94803, 94804, 94805, 94806, 94901, 94903, 94904, 94920, 94922, 94924,
  94925, 94928, 94929, 94930, 94931, 94933, 94937, 94938, 94939, 94940, 94941,
  94945, 94946, 94947, 94949, 94950, 94951, 94952, 94954, 94956, 94957, 94960,
  94963, 94964, 94965, 94970, 94971, 94972, 94973, 95002, 95003, 95005, 95006,
  95007, 95008, 95013, 95014, 95017, 95018, 95030, 95032, 95033, 95035, 95037,
  95041, 95046, 95050, 95051, 95053, 95054, 95060, 95065, 95066, 95070, 95073,
  95101, 95103, 95106, 95108, 95109, 95110, 95111, 95112, 95113, 95116, 95117,
  95118, 95119, 95120, 95121, 95122, 95123, 95124, 95125, 95126, 95127, 95128,
  95129, 95130, 95131, 95132, 95133, 95134, 95135, 95136, 95138, 95139, 95140,
  95141, 95148, 95150, 95151, 95152, 95153, 95154, 95155, 95156, 95157, 95158,
  95159, 95160, 95161, 95164, 95170, 95172, 95173, 95191, 95192, 95196, 95202,
  95203, 95204, 95205, 95206, 95207, 95209, 95210, 95211, 95212, 95215, 95219,
  95220, 95223, 95226, 95227, 95231, 95237, 95240, 95242, 95253, 95254, 95258,
  95304, 95330, 95336, 95337, 95350, 95356, 95358, 95360, 95363, 95366, 95368,
  95376, 95377, 95385, 95387, 95391, 95405, 95407, 95409, 95431, 95442, 95452,
  95472, 95476, 95601, 95602, 95603, 95604, 95605, 95606, 95607, 95608, 95610,
  95612, 95613, 95614, 95615, 95616, 95618, 95619, 95620, 95621, 95623, 95624,
  95625, 95626, 95627, 95628, 95629, 95630, 95631, 95632, 95633, 95634, 95635,
  95636, 95637, 95638, 95639, 95640, 95641, 95642, 95645, 95646, 95648, 95650,
  95651, 95652, 95653, 95655, 95658, 95659, 95660, 95661, 95662, 95663, 95664,
  95666, 95667, 95668, 95669, 95670, 95671, 95672, 95673, 95674, 95675, 95676,
  95677, 95678, 95680, 95681, 95682, 95683, 95684, 95685, 95686, 95687, 95688,
  95689, 95690, 95691, 95692, 95693, 95694, 95695, 95697, 95698, 95699, 95701,
  95703, 95709, 95713, 95714, 95717, 95720, 95721, 95722, 95726, 95728, 95735,
  95736, 95742, 95746, 95747, 95757, 95758, 95762, 95765, 95776, 95811, 95812,
  95813, 95814, 95815, 95816, 95817, 95818, 95819, 95820, 95821, 95822, 95823,
  95824, 95825, 95826, 95827, 95828, 95829, 95830, 95831, 95832, 95833, 95834,
  95835, 95836, 95837, 95838, 95840, 95841, 95842, 95843, 95851, 95852, 95853,
  95860, 95864, 95865, 95866, 95867, 95894, 95901, 95903, 95912, 95914, 95917,
  95918, 95919, 95932, 95935, 95937, 95945, 95946, 95948, 95949, 95950, 95953,
  95957, 95959, 95960, 95961, 95962, 95966, 95968, 95972, 95975, 95977, 95982,
  95991, 95993, 96111, 96120, 96140, 96141, 96142, 96143, 96145, 96146, 96148,
  96150, 96155, 96161, 98001, 98002, 98003, 98004, 98005, 98006, 98007, 98008,
  98010, 98011, 98012, 98014, 98019, 98020, 98021, 98022, 98023, 98024, 98025,
  98026, 98027, 98028, 98029, 98030, 98031, 98032, 98033, 98034, 98036, 98037,
  98038, 98039, 98040, 98042, 98043, 98045, 98047, 98050, 98051, 98052, 98053,
  98055, 98056, 98057, 98058, 98059, 98065, 98068, 98070, 98072, 98074, 98075,
  98077, 98087, 98092, 98101, 98102, 98103, 98104, 98105, 98106, 98107, 98108,
  98109, 98110, 98111, 98112, 98113, 98114, 98115, 98116, 98117, 98118, 98119,
  98121, 98122, 98124, 98125, 98126, 98127, 98129, 98131, 98133, 98134, 98136,
  98138, 98139, 98144, 98145, 98146, 98148, 98154, 98155, 98158, 98161, 98164,
  98165, 98166, 98168, 98170, 98174, 98175, 98177, 98178, 98181, 98185, 98188,
  98191, 98194, 98195, 98198, 98199, 98201, 98203, 98204, 98207, 98208, 98223,
  98224, 98236, 98239, 98249, 98251, 98252, 98253, 98256, 98258, 98260, 98270,
  98271, 98272, 98275, 98282, 98288, 98290, 98292, 98294, 98296, 98303, 98310,
  98311, 98312, 98314, 98315, 98320, 98321, 98323, 98325, 98327, 98329, 98332,
  98333, 98335, 98337, 98338, 98339, 98340, 98342, 98345, 98346, 98349, 98351,
  98353, 98354, 98358, 98359, 98360, 98364, 98365, 98366, 98367, 98368, 98370,
  98371, 98372, 98373, 98374, 98375, 98376, 98380, 98382, 98383, 98385, 98387,
  98388, 98390, 98391, 98392, 98394, 98396, 98402, 98403, 98404, 98405, 98406,
  98407, 98408, 98409, 98416, 98418, 98421, 98422, 98424, 98430, 98433, 98438,
  98439, 98443, 98444, 98445, 98446, 98447, 98465, 98466, 98467, 98498, 98499,
  98502, 98503, 98505, 98506, 98513, 98516, 98524, 98528, 98546, 98555, 98558,
  98580, 98584, 98588, 98592,
];
